/* Goddess Kaftans collection page — filter drawer + sort behavior.
   Scoped to elements inside [data-gk-plp]; touches nothing else in the theme. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-gk-plp]');
    if (!root) return;

    var drawer = root.querySelector('[data-gk-filter-drawer]');
    var backdrop = root.querySelector('[data-gk-filter-backdrop]');
    var openBtn = root.querySelector('[data-gk-filter-open]');
    var closeBtn = root.querySelector('[data-gk-filter-close]');
    var sortWrap = root.querySelector('[data-gk-sort]');
    var sortToggle = root.querySelector('[data-gk-sort-toggle]');
    var sortMenu = root.querySelector('[data-gk-sort-menu]');

    function openDrawer() {
      drawer.setAttribute('data-open', 'true');
      backdrop.setAttribute('data-open', 'true');
      drawer.removeAttribute('hidden');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var firstField = drawer.querySelector('input, button, select, a');
      if (firstField) firstField.focus();
    }

    function closeDrawer() {
      drawer.setAttribute('data-open', 'false');
      backdrop.setAttribute('data-open', 'false');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        if (drawer.getAttribute('data-open') === 'false') {
          drawer.setAttribute('hidden', '');
        }
      }, 220);
      openBtn.focus();
    }

    if (openBtn && drawer && backdrop) {
      openBtn.addEventListener('click', openDrawer);
      closeBtn && closeBtn.addEventListener('click', closeDrawer);
      backdrop.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
          closeDrawer();
        }
      });
    }

    if (sortWrap && sortToggle && sortMenu) {
      function openSortMenu() {
        sortMenu.removeAttribute('hidden');
        sortToggle.setAttribute('aria-expanded', 'true');
      }

      function closeSortMenu() {
        sortMenu.setAttribute('hidden', '');
        sortToggle.setAttribute('aria-expanded', 'false');
      }

      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (sortMenu.hasAttribute('hidden')) {
          openSortMenu();
        } else {
          closeSortMenu();
        }
      });

      document.addEventListener('click', function (e) {
        if (!sortWrap.contains(e.target)) closeSortMenu();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sortMenu.hasAttribute('hidden')) {
          closeSortMenu();
          sortToggle.focus();
        }
      });
    }

    /* Load More — replaces numbered pagination. Fetches the next page's
       rendering of THIS section (via ?section_id=) and moves only its grid
       items into the current grid, so no full page navigation happens. */
    var grid = root.querySelector('[data-gk-grid]');
    var loadMoreWrap = root.querySelector('[data-gk-load-more-wrap]');

    if (grid && loadMoreWrap) {
      loadMoreWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gk-load-more-btn]');
        if (!btn || btn.disabled) return;

        var nextUrl = btn.getAttribute('data-next-url');
        var sectionId = btn.getAttribute('data-section-id');
        if (!nextUrl) return;

        var originalLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Loading…';

        var sep = nextUrl.indexOf('?') > -1 ? '&' : '?';
        var fetchUrl = nextUrl + sep + 'section_id=' + encodeURIComponent(sectionId);

        fetch(fetchUrl)
          .then(function (res) {
            if (!res.ok) throw new Error('Load more request failed');
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll('[data-gk-grid] > .gk-grid__item');
            newItems.forEach(function (item) {
              grid.appendChild(item);
            });

            var newBtn = doc.querySelector('[data-gk-load-more-btn]');
            if (newBtn) {
              btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
              btn.disabled = false;
              btn.textContent = originalLabel;
            } else {
              loadMoreWrap.parentNode && loadMoreWrap.remove();
            }
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalLabel;
          });
      });
    }
  });
})();
